import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  MenuItem,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { createChecklistResposta } from "../../api/checkilstApi";
import { RESPOSTA_OPTIONS, descricaoToValor } from "../../utils/respostaMap";

type FormValues = {
  ordem_checklist_resposta: number;
  descricao_checklist_resposta: string | null;
  valor_checklist_respostas: string | null;
};

const NovaResposta: React.FC = () => {
  const { perguntaId } = useParams<{ perguntaId: string }>();
  const id_checklist_pergunta = Number(perguntaId);
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { control, handleSubmit, reset, watch } = useForm<FormValues>({
    defaultValues: {
      ordem_checklist_resposta: 0,
      descricao_checklist_resposta: null,
      valor_checklist_respostas: null,
    },
  });

  const watchedDescricao = watch("descricao_checklist_resposta");

  useEffect(() => {
    const auto = descricaoToValor(watchedDescricao ?? null);
    reset((prev) => ({
      ...prev,
      valor_checklist_respostas:
        watchedDescricao === "Desc" ? "null" : auto ?? null,
    }));
  }, [watchedDescricao, reset]);

  const onSubmit = async (form: FormValues) => {
    try {
      setSaving(true);
      const token = localStorage.getItem("token") || "";

      const payload = {
        ordem_checklist_resposta: Number(form.ordem_checklist_resposta),
        descricao_checklist_resposta: form.descricao_checklist_resposta,
        valor_checklist_respostas:
          form.descricao_checklist_resposta === "Desc"
            ? "null"
            : form.valor_checklist_respostas ?? null,
        id_checklist_pergunta,
      };

      await createChecklistResposta(token, payload);
      toast.success("Resposta criada com sucesso!");
      navigate(-1);
    } catch (err) {
      console.error(err);
      toast.error("Erro ao criar resposta");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 600 }}>
      <Typography variant="h5" mb={2}>
        Nova Respostassssss - Pergunta #{id_checklist_pergunta}
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="ordem_checklist_resposta"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              type="number"
              label="Ordem"
              fullWidth
              margin="normal"
            />
          )}
        />

        <Controller
          name="descricao_checklist_resposta"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              select
              label="Descrição da Resposta"
              fullWidth
              margin="normal"
            >
              {RESPOSTA_OPTIONS.map((opt) => (
                <MenuItem key={opt.label} value={opt.label}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        />

        {watchedDescricao === "__custom" ? (
          <Controller
            name="descricao_checklist_resposta"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Descrição (custom)"
                fullWidth
                margin="normal"
              />
            )}
          />
        ) : null}

        <Controller
          name="valor_checklist_respostas"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              value={field.value ?? ""}
              label="Valor da Resposta"
              fullWidth
              margin="normal"
              disabled
            />
          )}
        />

        <Box mt={2} display="flex" gap={2}>
          <Button variant="contained" type="submit" disabled={saving}>
            {saving ? <CircularProgress size={24} /> : "Salvar Resposta"}
          </Button>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Voltar
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default NovaResposta;
